module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/welcome-300x300.7aedfcf0.jpg";